import React from "react";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { FullscreenDisableIconComponent } from "../../../icons/fullscreen/FullscreenDisableIconComponent";
import { FullscreenEnableIconComponent } from "../../../icons/fullscreen/FullscreenEnableIconComponent";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";

interface Props {
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
}

export const DesktopFullscreenControlComponent: React.SFC<Props> = ({ isFullscreen, onToggleFullscreen, onCancelTooltip, onRequestTooltip }) => {
  const fullscreenIcon = isFullscreen ? <FullscreenDisableIconComponent /> : <FullscreenEnableIconComponent />;
  return (
    <MenuButtonWithTooltipComponent
      onClick={onToggleFullscreen}
      icon={fullscreenIcon}
      tooltipTarget="fullscreenControl"
      onCancelTooltip={onCancelTooltip}
      onRequestTooltip={onRequestTooltip}
    />
  );
};
